import { adaptDestinations } from './adapter';
import type { ApiDestination } from './types';
import { useTravelataApiService } from '@/shared/composables/useTravelataApiService';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';
import type { Destination } from '@/shared/model';

const cache = new Map<string, Destination[]>();

export function clearOptionsCache(): void {
  cache.clear();
}

export async function getOptions(term: string): Promise<Destination[]> {
  const key = term.toLowerCase();

  const cached = cache.get(key);
  if (cached !== undefined) {
    return cached;
  }

  try {
    const apiService = useTravelataApiService();
    const config = useTravelataAppConfig();

    const response = await apiService.get<unknown>(config.intelligentSearch, {
      params: { term: key, clientUUID: config.clientUuid },
    });

    const list: ApiDestination[] = Array.isArray(response)
      ? (response as ApiDestination[])
      : response && Array.isArray((response as { result?: unknown }).result)
      ? (response as { result: ApiDestination[] }).result
      : [];
    const destinations = adaptDestinations(list);

    cache.set(key, destinations);
    return destinations;
  } catch {
    return [];
  }
}
